<template>
    <div class="listing-wrapper-loading-state">
        <div class="listing-wrapper-loading-state__header">
            <CompassSkeleton class="listing-wrapper-loading-state__skeleton-title" size="x-large" />
        </div>
        <TableLoading />
    </div>
</template>

<script>
import TableLoading from 'vcomponents/common/table/TableLoading.vue';

export default {
    components: {
        TableLoading,
    },
};
</script>

<style scoped lang="scss">
.listing-wrapper-loading-state {
    &__header {
        width: 300px;
        margin-bottom: var(--spacing-4);
    }
}
</style>
